import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    const style = {
        margin: '50px 0',  /* adjust this value as needed */
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px'
    };

    const linkStyle = {
        color: '#666',
        textDecoration: 'none',
        fontSize: '14px'
    };

    const currentYear = new Date().getFullYear();

    return (
        <footer style={style}>
            <span>© {currentYear} EdXcelerate</span>
            <Link to="/privacy-policy" style={linkStyle}>Privacy Policy</Link>
        </footer>
    );
}

export default Footer;
